var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prospect-request-end-action"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v(_vm._s(_vm.subtitle))]),_c('mcr-button-router-link-to-pr',{attrs:{"label":_vm.buttonLabel},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }